import React from "react";
import MenuListItem from "@mui/material/MenuItem";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { Icon, IconColor } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const useDropdownItemClasses = makeStyles()((theme, _params, classes) => ({
  dropdownItem: {
    width: "100%",
    [`&.Mui-selected .${classes.dropdownItemConfirmIcon}`]: {
      display: "block"
    }
  },
  dropdownItemIcon: {
    marginRight: theme.spacing(1),
    display: "flex",
    justifyContent: "center",
    width: theme.custom.dropdownIconWidth
  },
  dropdownItemConfirmIcon: {
    display: "none",
    marginLeft: "auto"
  }
}));
const DropdownItem = ({ icon, label, confirmIcon, className, ...menuItemProps }) => {
  const { classes } = useDropdownItemClasses();
  const key = typeof label === "string" ? label : label.id;
  return /* @__PURE__ */ React.createElement(MenuListItem, { className: `${classes.dropdownItem} ${className}`, ...menuItemProps, key }, icon ? /* @__PURE__ */ React.createElement("span", { className: classes.dropdownItemIcon }, icon) : /* @__PURE__ */ React.createElement(React.Fragment, null), label ? /* @__PURE__ */ React.createElement(LocalizedText, { label }) : null, confirmIcon ? /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.Confirm, color: IconColor.Primary, className: classes.dropdownItemConfirmIcon }) : null);
};
export {
  DropdownItem
};
//# sourceMappingURL=DropdownItem.js.map
